import { useEffect, useState } from 'react';
import { noticeAPI } from '../../api/notice';

// 공지는 페이지당 한 번만 받아 모달과 배너가 같이 쓴다
let pending = null;

export function fetchNotice() {
  if (!pending) {
    pending = noticeAPI()
      .then((resp) => (resp && resp.status === 200 && resp.data ? resp.data.notice || null : null))
      .catch(() => null);
  }
  return pending;
}

export default function useNotice() {
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchNotice().then((n) => { if (alive) setNotice(n); });
    return () => { alive = false; };
  }, []);
  return notice;
}

// 로컬 날짜 YYYY-MM-DD — '오늘 하루 보지 않기' 기준
export function todayKey() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
